module.exports = __webpack_public_path__ + "img/image_031.113d41b9.jpg";